import React, { useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import signatureService from "../../../services/signature/SignatureService";
import Card from "../../../components/Card";
import { formatDateTimeLocalDate } from "../../../utilities/Utils";
import { Badge, Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";

const ExpandableComponentSmkhpFinal = ({ data }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [listSmkhpFile, setListSmkhpFile] = useState([])
    const [loading, setLoading] = useState(false)

    const columns = [
        {
            name: 'Nomor Dokumen',
            cell: row => (
                <>{row['noHcMutu']}/{row['noSeriMutuElectronic']}</>
            ),
            grow: 0.5
        },
        {
            name: 'File',
            cell: row => {
                if (row.isSignedFile) {
                    return (
                        <div className="row">
                            <div className="col-12">
                                <Link
                                    to={`/signature/${row.documentId}/signed`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {row.dokName}
                                </Link>
                            </div>
                        </div>
                    )
                }

                return (
                <div className="row">
                    <div className="col-12">
                            <a href={row['dokPath']} target="_blank" rel="noopener noreferrer">
                                {row['dokName']}
                            </a>
                    </div>
                </div>
            )
            }
        },
        {
            name: 'Status',
            cell: row => row.isSignedFile ? (
                <Badge bg="success">SUDAH TTE</Badge>
            ) : (
                <Badge bg="secondary">FILE ASLI</Badge>
            )
        },
        {
            name: 'Tanggal Dibuat',
            cell: row => formatDateTimeLocalDate(row['createdDate'])
        }
    ]

    useEffect(() => {
        if (!data?.nomorAju || !data?.noHcMutu) {
            return
        }

        let active = true

        const fetchAllData = async () => {
            setLoading(true)
            try {
                const resFile = await transaksiService.listSmkhpFileFinalFor(data?.nomorAju, data?.noHcMutu, '1')
                const files = resFile?.data?.data || []

                // File hasil TTE disimpan terpisah dari TrHcFile asli di signature service.
                // Periksa status setiap documentId, lalu tambahkan virtual row untuk file signed.
                const signedRows = await Promise.all(
                    files.map(async file => {
                        if (!file?.id) {
                            return null
                        }

                        try {
                            const resStatus = await signatureService.getStatus(file.id)
                            const status = resStatus?.data || {}
                            const isSigned = status.signed === true || status.status === 'SIGNED'

                            if (!isSigned) {
                                return null
                            }

                            return {
                                ...file,
                                id: `${file.id}-signed`,
                                documentId: file.id,
                                dokName: `TTE - ${file.dokName || `SMKHP-${file.id}.pdf`}`,
                                dokPath: null,
                                isSignedFile: true,
                                signatureStage: status.signatureStage,
                                signatureStatus: status.status
                            }
            } catch (error) {
                            // Status signature tidak boleh membuat file asli hilang dari expand.
                            return null
                        }
                    })
                )

                const signedFiles = signedRows.filter(Boolean)
                const rows = files.flatMap(file => {
                    const signedFile = signedFiles.find(item => item.documentId === file.id)
                    return signedFile ? [file, signedFile] : [file]
                })

                if (active) {
                    setListSmkhpFile(rows)
                }
            } catch (error) {
                if (active) {
                setListSmkhpFile([])
            }
            } finally {
                if (active) {
            setLoading(false)
        }
            }
        }

        fetchAllData()

        return () => {
            active = false
        }
    }, [transaksiService, data])

    return (
        <>
            <Card>
                <Card.Body>
                    <div className="table-responsive border-bottom my-3">
                        {(loading && <Spinner />)}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listSmkhpFile}
                            highlightOnHover
                            pagination
                            persistTableHead={true}
                        />
                    </div>
                </Card.Body>
            </Card>
        </>
    )

}

export default ExpandableComponentSmkhpFinal